import { IHealthDashboardData } from 'src/apis/dashboard/dashboardHealth.interfaces';

export const dashboardHealthMock: IHealthDashboardData = {
  summary: {
    totalIncidents: 100,
    activeIncidents: 100,
    totalCheckups: 100,
    pendingCheckups: 100,
    complianceRate: 100,
  },
  incidents: {
    total: 100,
    byType: {
      injury: 100,
      illness: 100,
      accident: 100,
      emergency: 100,
      allergy: 100,
      other: 100,
    },
    bySeverity: {
      low: 100,
      medium: 100,
      high: 100,
      critical: 100,
    },
    byStatus: {
      open: 100,
      inProgress: 100,
      resolved: 100,
      closed: 100,
    },
  },
  checkups: {
    total: 100,
    pending: 100,
    completed: 100,
    overdue: 100,
    byType: {
      annual: 100,
      medical: 100,
      dental: 100,
      vision: 100,
      hearing: 100,
      vaccination: 100,
    },
  },
  compliance: {
    totalInspections: 100,
    compliant: 100,
    nonCompliant: 100,
    pending: 100,
    compliancePercentage: 100,
  },
  period: {
    startDate: '2024-01-01',
    endDate: '2024-12-31',
  },
};
